module.exports = "/group@2x-045be323a9f7b941191921282372efa3.png";